export type FlowIdentifier = 'default'
  | 'proceed'
// idx.authenticate
  | 'authenticate'
  | 'login'
  | 'signin'
// idx.register
  | 'register'
  | 'signup'
  | 'enrollProfile'
// idx.recoverPassword
  | 'recoverPassword'
  | 'resetPassword'
// idx.unlockAccount
  | 'unlockAccount';
